import { OnInit } from '@angular/core';
var AnnexComponent = /** @class */ (function () {
    function AnnexComponent() {
    }
    AnnexComponent.prototype.ngOnInit = function () {
    };
    return AnnexComponent;
}());
export { AnnexComponent };
